/* Thumbnails and arrows for the scroll-snap gallery. The track itself swipes natively. */
if (!customElements.get('veya-gallery')) {
  customElements.define('veya-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.veya-gallery__track');
      this.slides = Array.from(this.querySelectorAll('[data-veya-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-veya-go]'));
      if (!this.track || this.slides.length === 0) return;
      this.index = 0;

      this.onClick = (event) => {
        const go = event.target.closest('[data-veya-go]');
        const step = event.target.closest('[data-veya-step]');
        if (go) this.goTo(Number(go.dataset.veyaGo));
        else if (step) this.goTo(this.index + Number(step.dataset.veyaStep));
      };
      this.addEventListener('click', this.onClick);

      // The slide most in view is the current one, however it got there.
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.setCurrent(this.slides.indexOf(entry.target));
        });
      }, { root: this.track, threshold: 0.6 });
      this.slides.forEach((slide) => this.io.observe(slide));
      this.setCurrent(0);
    }

    goTo(index) {
      const count = this.slides.length;
      const next = (index + count) % count;
      // Offset within the track, measured the same way in LTR and RTL.
      const left = this.slides[next].offsetLeft - this.slides[0].offsetLeft;
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.setCurrent(next);
    }

    setCurrent(index) {
      if (index < 0) return;
      this.index = index;
      this.thumbs.forEach((thumb, i) => {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    disconnectedCallback() {
      this.io?.disconnect();
      this.removeEventListener('click', this.onClick);
    }
  });
}
